const { populate } = require('@/functions/objects');
const { toInt, toString } = require('@/functions/transform');

class KitchenZone {
    constructor(data = {}) {
        /**
         * @type {Number}
         */
        this.ID = null;

        /**
         * @type {Number}
         */
        this.branchID = null;

        /**
         * @type {string}
         */
        this.name = '';

        populate(this, data);
    }

    getHydrationMap() {
        return {
            branchID: toInt,
            ID: {
                field: ['kitchenZoneID', 'ID'],
                transform: toInt,
            },
            name: toString,
        };
    }
}

module.exports = KitchenZone;
